import { useFlags } from 'launchdarkly-react-client-sdk';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  sideContainerStyleFirstBox,
  sideContainerStyleInnerBox,
} from './CepConfigView.styles';
import InfoTag from 'components/InfoTag/InfoTag';
import { CepViewPropsType } from 'routes/AuthenticatedApp/CepView/CepView.types';
import useCepConfigView from 'routes/AuthenticatedApp/CepView/Steps/CepConfigView/CepConfigView.hook';
import Box from 'yoda-ui/components/Box';
import Loader from 'yoda-ui/components/Loader';

const CepConfigView: FC<CepViewPropsType> = () => {
  const { t } = useTranslation();
  const {
    cep,
    date,
    loading,
    productName,
  } = useCepConfigView();

  const flags = useFlags();

  return (
    <>
      {
        loading
          ? (
            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Loader center />
            </Box>
          )
          : (
            <Box>
              <Box sx={ sideContainerStyleFirstBox }>
                <Box>
                  <Box sx={ sideContainerStyleInnerBox }>
                    <InfoTag
                      title={ t('maya_cep_view_title') }
                      field={ cep?.title }
                    />
                    <InfoTag
                      title={ t('maya_cep_view_ci_title') }
                      field={ cep?.customerInitiative.title }
                    />
                    <InfoTag
                      title={ t('maya_cep_view_date') }
                      field={ date }
                    />
                    <InfoTag
                      title={ t('maya_cep_view_therapeutic_area') }
                      field={ cep?.therapeuticArea }
                    />
                    <InfoTag
                      title={ t('maya_cep_view_product') }
                      field={ productName }
                    />
                    <InfoTag
                      title={ t('maya_cep_view_functional_owner') }
                      field={ cep?.biogenFunction }
                    />
                    {
                      !flags?.mayaAkma264RemovalOfUnusedFields ? (
                        <InfoTag
                          title={ t('maya_cep_view_kpi') }
                          field={ cep?.kpi }
                        />
                      ) : null
                    }
                  </Box>
                </Box>
              </Box>
            </Box>
          )
      }
    </>
  );
};

export default CepConfigView;

